import { render, staticRenderFns } from "./notifyInfo.vue?vue&type=template&id=1c33c90c&scoped=true"
import script from "./notifyInfo.vue?vue&type=script&lang=js"
export * from "./notifyInfo.vue?vue&type=script&lang=js"
import style0 from "./notifyInfo.vue?vue&type=style&index=0&id=1c33c90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33c90c",
  null
  
)

export default component.exports